"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NetDownloadIcon16Light_1 = require("./icons/NetDownloadIcon/NetDownloadIcon16Light");
Object.defineProperty(exports, "NetDownloadIcon16Light", { enumerable: true, get: function () { return NetDownloadIcon16Light_1.NetDownloadIcon16Light; } });
